import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { storeAuthFromToken } from "../utils/auth";

export default function SsoCallbackPage({ onAuth }) {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      navigate("/sso", { replace: true });
      return;
    }
    const user = storeAuthFromToken(token);
    if (!user) {
      setError("Invalid SSO token. Please relaunch from the Master Dashboard.");
      return;
    }
    if (onAuth) onAuth(user);
    window.history.replaceState({}, "", window.location.pathname);
    navigate("/dashboard", { replace: true });
  }, [navigate, onAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bgLight">
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8 w-full max-w-lg space-y-3 text-center">
        <h1 className="text-xl font-semibold text-navy">Signing you in…</h1>
        <p className="text-sm text-slate-600">
          Please wait while we finish your SSO session.
        </p>
        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
      </div>
    </div>
  );
}
